const MAX_INTEGER_DIGITS = 15;

export const MAX_FORMATTED_NUMBER_LENGTH = MAX_INTEGER_DIGITS + Math.floor((MAX_INTEGER_DIGITS - 1) / 3);

export const formatNumberWithSpaces = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  const digits = String(value).replace(/\D/g, '').slice(0, MAX_INTEGER_DIGITS);
  if (!digits) {
    return '';
  }
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const parseNumberFromSpaces = (input: string | undefined | null): number | undefined => {
  if (!input) {
    return undefined;
  }
  const digits = String(input).replace(/\D/g, '').slice(0, MAX_INTEGER_DIGITS);
  if (!digits) {
    return undefined;
  }
  const parsed = Number(digits);
  return Number.isFinite(parsed) ? parsed : undefined;
};
